import Vue from 'vue'
import VueI18n from 'vue-i18n'
import VueRouter from 'vue-router'
import VueAnalytics from 'vue-analytics'

import './plugins/bootstrap'
import './plugins/icons'
import './plugins/murmur'

import routes from './router'
import guard from './router/guard'
import messages from './i18n'
import store from './store'
import './main.scss'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(VueI18n)

const render = h => h('div', { attrs: { id: 'app' } }, [
  h('RouterView')
])

const i18n = new VueI18n({ locale: 'en', messages })

const router = new VueRouter({ routes })

Vue.use(VueAnalytics, {
  id: 'UA-3383794-15',
  router,
  autoTracking: {
    pageviewTemplate (route) {
      return {
        page: '/investigations/uber-files/#/key-figures-in-uber-files/' + route.path,
        title: document.title,
        location: window.location.href
      }
    }
  }
})
// Add guards to the router before the main Vue instance is created so we
// can set the initial route with unnecessary rendering
guard({ router, i18n, store })

new Vue({ router, render, i18n, store }).$mount('#app')
